import * as React from 'react';
import { InviteUserDialogModel, TeamItemModel } from './model/TeamModel';
import { TeamController } from './controller/TeamController';
import { Dialog } from 'components/dialog';
import { TextField } from 'components/input/TextField';
import { SimpleSelect, SelectItem } from 'components/input/SimpleSelect';
import { EUserRole } from 'utils/meta';
import { Button } from '@material-ui/core';

export class InviteUserDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        var m = props.model;
        this.state = {
            name: m.name,
            email: m.email,
            role: m.role,
            teamId: m.teamId,
            yearlyVacations: m.yearlyVacations,
            rolledVacations: m.rolledVacations,
            usedUpVacations: m.usedUpVacations
        };

        this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
        this.handleInviteButtonClicked = this.handleInviteButtonClicked.bind(this);
    }

    private handleCancelButtonClicked() {
        this.props.controller.onInviteUserCancelClicked();
    }

    private handleInviteButtonClicked() {
        var m = this.props.model;
        m.name = this.state.name;
        m.email = this.state.email;
        m.role = this.state.role;
        m.teamId = this.state.teamId;
        m.yearlyVacations = this.state.yearlyVacations;
        m.rolledVacations = this.state.rolledVacations;
        m.usedUpVacations = this.state.usedUpVacations;
        this.props.controller.onInviteUserSaveClicked(m);
    }

    public render() {
        return (
            <Dialog title="Invite user" desc="Fill the form below to invite a colleague to use Humen!">
                <TextField label="Name" value={this.state.name} desc="The name of the user" error={this.props.model.nameError} onChange={(v) => { this.setState({ name: v }) }} />
                <TextField label="Email" value={this.state.email} desc="The email address of the user. The invitation will be sent to this email." error={this.props.model.emailError} onChange={(v) => { this.setState({ email: v }) }} />
                <SimpleSelect label="Role" defaultValue={this.state.role} error={this.props.model.roleError} infoText="Choose a role for this user!" onChange={(v) => { this.setState({ role: v }) }}>
                    {EUserRole.values().map((r) => (<SelectItem key={"role-" + r.name} value={r.name} title={r.title} />))}
                </SimpleSelect>
                <SimpleSelect label="Team" defaultValue={this.state.teamId} error={this.props.model.teamError} infoText="Choose a team for this user!" onChange={(v) => { this.setState({ teamId: v }) }}>
                    {[<SelectItem key="team-none" value="" title="No team" />].concat(this.props.teams.map((t) => (<SelectItem key={"team-" + t.id} value={"" + t.id} title={t.name} />)))}
                </SimpleSelect>
                <TextField label="This year vacation count" value={this.state.yearlyVacations} desc="The count of vacations this year." error={this.props.model.yearlyVacationsError} onChange={(v) => { this.setState({ yearlyVacations: v }) }} />
                <TextField label="Rolled vacation count" value={this.state.rolledVacations} desc="Unused vacations count from previous year." error={this.props.model.rolledVacationsError} onChange={(v) => { this.setState({ rolledVacations: v }) }} />
                <TextField label="Used up vacation count" value={this.state.usedUpVacations} desc="The count of used up vacations this year." error={this.props.model.usedUpVacationsError} onChange={(v) => { this.setState({ usedUpVacations: v }) }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleInviteButtonClicked}>Invite</Button>
                </div>
            </Dialog>
        );
    }

}

export interface Props {

    model: InviteUserDialogModel;
    teams: TeamItemModel[];
    controller: TeamController;

}

interface State {

    name: string;
    email: string;
    role: string;
    teamId: string;
    yearlyVacations: string;
    rolledVacations: string;
    usedUpVacations: string;

}
